"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilIconExpandMore = void 0;
var react_1 = __importDefault(require("react"));
var IconBase_1 = __importDefault(require("../IconBase"));
var utils_1 = require("../utils");
var ExpandMore = function (props) { return (react_1.default.createElement(IconBase_1.default, __assign({}, props),
    react_1.default.createElement("path", { d: "M10.9412 17.5606C11.527 18.1464 12.4767 18.1464 13.0625 17.5606L20.8407 9.78246C21.4265 9.19668 21.4265 8.24693 20.8407 7.66114C20.2549 7.07536 19.3052 7.07536 18.7194 7.66114L12.0019 14.3787L5.28435 7.66114C4.69857 7.07536 3.74882 7.07536 3.16303 7.66114C2.57725 8.24693 2.57725 9.19668 3.16303 9.78246L10.9412 17.5606Z" }))); };
exports.UtilIconExpandMore = (0, utils_1.withDeprecationWarning)(ExpandMore, 'UtilIconExpandMore');
exports.default = ExpandMore;
